import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Stream } from 'src/models/stream';
import { InfiniteScrollableComponent } from '../base/infinite-scrollable/infinite-scrollable.component';
import { AlertBoxType } from '../base/alert-box/alertboxtype';
import { ActivatedRoute } from '@angular/router';
import { PlayerService } from 'src/app/services/player.service';
import { switchMap } from 'rxjs/operators';
import { PodcastService } from 'src/app/services/podcast.service';
import { PodcastSearchResult } from 'src/models/podcast-search-result';

@Component({
  selector: 'app-podcast-search-result',
  templateUrl: './podcast-search-result.component.html',
  styleUrls: ['./podcast-search-result.component.scss']
})
export class PodcastSearchResultComponent extends InfiniteScrollableComponent implements OnInit {

  public alertBoxTypes = AlertBoxType;

  public podcasts = new Array<Stream>();

  private itemsPerPage = 10;

  private searchText: string;

  public scrollControlEnabled = false;

  public loading = true;

  public nextOffset = 0;

  constructor(
    private route: ActivatedRoute,
    private podcastService: PodcastService,
    private playerService: PlayerService,
    private changeDetector: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {

    // use switchmap to prevent race conditions
    this.route.params.pipe(
      switchMap(params => {
        
        this.scrollControlEnabled = false;
        this.loading = true;

        this.searchText = params['searchText'];

        this.podcasts = new Array<Stream>();
        this.start = 0;
        this.nextOffset = 0;

        return this.podcastService.getPodcastsByName(this.searchText, this.nextOffset);
      })
    ).subscribe((searchResult: PodcastSearchResult) => {
      searchResult.results.forEach((podcast: Stream) => this.podcasts.push(podcast));

      if (searchResult.results.length === 20) {
        this.scrollControlEnabled = true;
      }

      this.nextOffset = searchResult.nextOffset;

      this.loading = false;

      this.changeDetector.detectChanges();
    });

  }

  protected getItemsPerPage(): number {
    return this.itemsPerPage;
  }

  protected loadStreams() {
    this.scrollControlEnabled = false;
    this.loading = true;

    this.podcastService.getPodcastsByName(this.searchText, this.nextOffset).subscribe((searchResult: PodcastSearchResult) => {
      searchResult.results.forEach((podcast: Stream) => this.podcasts.push(podcast));

      if (searchResult.results.length === this.itemsPerPage) {
        this.scrollControlEnabled = true;
      }

      this.nextOffset = searchResult.nextOffset;

      this.loading = false;

      this.changeDetector.detectChanges();
    });
  }

  public onPlayStreamClicked(stream: Stream) {
    this.playerService.setCurrentStream(stream);
  }

}
